import React, { useEffect, useState } from 'react';
// import { DatePicker } from '@superops/ui-design-system';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import { DisplayText } from '@superops/ui-design-system';

const CustomDateTimeField = (props) => {
  const { field, value, onChange, isDisabled, portalId } = props;
  const { fieldType, label } = field;

  const [currentValue, setCurrentValue] = useState(value);

  const currentValueByRef = React.useRef(null);
  currentValueByRef.current = currentValue;

  const updateValue = (val) => {
    setCurrentValue(val);
    if (onChange && typeof onChange === 'function') {
      onChange(field, val);
    }
  };

  const getField = () => {
    const type = fieldType;
    switch (type) {
      case 'DATE':
      case 'date':
        return (
          <DatePicker
            selected={
              currentValueByRef.current
                ? dayjs(currentValueByRef.current).toDate()
                : ''
            }
            placeholderText="Choose date"
            onChange={(date) => {
              updateValue(date ? dayjs(date).format('YYYY-MM-DD') : '');
            }}
            dateFormat="yyyy-MM-dd"
            portalId={portalId || 'root-portal'}
          />
        );
      case 'DATETIME':
      case 'datetime':
        return (
          <DatePicker
            selected={
              currentValueByRef.current
                ? dayjs(currentValueByRef.current).toDate()
                : ''
            }
            placeholderText="Choose date"
            onChange={(date) => {
              updateValue(
                date ? dayjs(date).format('YYYY-MM-DDTHH:mm:ss') : ''
              );
            }}
            dateFormat="yyyy-MM-dd h:mm aa"
            showTimeInput
            portalId={portalId || 'root-portal'}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <>
      <div className="fields-wrapper">
        <DisplayText size="extraLarge" weight="Medium">
          {label}
        </DisplayText>
        <div className="custom-field-input">{getField()}</div>
      </div>
    </>
  );
};

export default CustomDateTimeField;
